import { v4 as uuidv4 } from 'uuid';

export function getUuid() {
  return uuidv4();
}
